import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import WorkspaceSettingsEditController from 'cio/pods/workspace-settings/edit/controller';
import DS from 'ember-data';
import UserModel from 'cio/models/user';
import Transition from '@ember/routing/-private/transition';
import isDestroyed from 'cio/utils/is-destroyed';
import ApiService from 'cio/services/api';
import EnvironmentService from 'cio/services/environment';
import AccountService from 'cio/services/account';

export default class EditRoute extends Route {
  @service store!: DS.Store;
  @service api!: ApiService;
  @service environment!: EnvironmentService;
  @service account!: AccountService;

  crumb() {
    return {
      name: 'Edit',
      path: this.routeName,
    };
  }

  async model() {
    let usersQuery = this.store.query('user', {});

    let hydraUsersPermissionsRequest = Promise.resolve(null);
    // If the account is CDP-only, we need to do a separate request to get the
    // permissions for the users in the workspace, as they don't come from
    // neither the `workspaces` endpoint nor the `enviroments` model.
    //
    // TODO: Should be removed once/if user_ids comes from the `workspaces`
    // endpoint, or other similar backend changes.
    if (!this.account.isJourneysAvailable) {
      hydraUsersPermissionsRequest = new Promise((resolve) => {
        this.api
          .request(`users_permissions/${this.environment.lastEnvironmentId}`, {
            pathScope: 'account',
            method: 'GET',
            ignoreErrors: true,
          })
          .then((response) => {
            resolve(response);
          })
          .catch(() => {
            // Request might fail if the user doesn't have permissions to access
            // the endpoint, but we don't want to block the user from editing
            // other fields in that case (or in any other case of failure really)
            resolve(null);
          });
      });
    }

    let [users, hydraUsersPermissions] = await Promise.all([usersQuery, hydraUsersPermissionsRequest]);

    return {
      users,
      hydraUsersPermissions,
    };
  }

  setupController(controller: WorkspaceSettingsEditController, model: UserModel, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.prepareInitialState();
  }

  deactivate() {
    super.deactivate();

    let controller = this.controller as WorkspaceSettingsEditController;

    if (!isDestroyed(this)) {
      controller.environment.current.rollbackAttributes();
    }
  }
}
